import './LegalPage.css';

function Help() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Help & Support</h1>
        <div className="meta">Get assistance with pholtr</div>

        <h2>Need Help?</h2>
        <p>
          We're here to help! If you have any questions, encounter issues, or need assistance with pholtr,
          please reach out to our support team.
        </p>

        <h2>Contact Support</h2>
        <p>
          Send an email to: <a href="mailto:info@pholter.com">info@pholter.com</a>
        </p>

        <h3>When contacting support, please include:</h3>
        <ul>
          <li>Your user ID (found on the profile page in the app)</li>
          <li>A clear description of your problem or question</li>
          <li>The steps you took that led to the issue (if applicable)</li>
          <li>Screenshots of any errors or problems you're experiencing (if applicable)</li>
          <li>Your device model and iOS version (if relevant)</li>
        </ul>

        <p>
          Providing detailed information and relevant screenshots helps us understand and resolve your issue more quickly.
        </p>

        <h2>Response Time</h2>
        <p>
          We aim to respond to all support inquiries within 24-48 hours. For urgent matters,
          please mention "URGENT" in your email subject line.
        </p>

        <footer>
          <a href="/">Back to Home</a>
        </footer>
      </div>
    </div>
  );
}

export default Help;
